import React, { useEffect, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function FAQ() {
  const [openFAQ, setOpenFAQ] = useState(null);
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const toggleFAQ = index => {
    if (openFAQ === index) {
      setOpenFAQ(null);
    } else {
      setOpenFAQ(index);
    }
  };
  const faqs = [{
    question: 'How long is the strategy call?',
    answer: 'Our strategy calls typically last 30 minutes. We respect your time and make sure to cover everything you need to know about our Facebook ad services efficiently.'
  }, {
    question: 'Is this just a sales pitch?',
    answer: "No. This is a genuine strategy session where we'll analyze your business needs and provide actionable insights. There's no obligation to work with us afterward."
  }, {
    question: 'Do I need to prepare anything for the call?',
    answer: "It's helpful to have a basic understanding of your business goals and target audience. If you have any current marketing materials or past campaign data, having those on hand can be useful but isn't required."
  }, {
    question: 'What happens after the call?',
    answer: "We'll send you a summary of our discussion and recommendations. If you decide to move forward, we'll create a customized campaign plan for your business. If not, you'll still have valuable insights to implement."
  }, {
    question: 'How quickly can you start running ads for my business?',
    answer: "Once we've finalized your campaign strategy and received the necessary assets, we can typically launch your first campaign within 5-7 business days. For urgent needs, we also offer expedited setup options."
  }, {
    question: 'What budget do I need for Facebook ads?',
    answer: "We recommend a minimum monthly ad spend of $1,500 to see meaningful results, though the ideal budget varies by industry and goals. During our strategy call, we'll provide specific budget recommendations for your business."
  }, {
    question: 'Do you offer any guarantees?',
    answer: "While we can't guarantee specific results due to the many variables in digital marketing, we do guarantee our expertise and commitment to optimizing your campaigns for the best possible performance. We're transparent about what's working and what needs adjustment."
  }, {
    question: 'How do you measure success?',
    answer: "We track key performance indicators aligned with your business goals, which may include lead quality, cost per acquisition, return on ad spend, and conversion rates. You'll receive regular reports showing exactly how your campaigns are performing."
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-307">
      <Header data-id="element-308" />
      <main data-id="element-309">
        <section className="py-20 bg-white" data-id="element-310">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-311">
            <div className="text-center mb-16" data-id="element-312">
              <h1 className="text-3xl md:text-5xl font-bold text-navy-900" data-id="element-313">
                Frequently Asked Questions
              </h1>
              <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-314">
                Everything you need to know about our Facebook ad services
              </p>
            </div>
            <div className="space-y-4" data-id="element-315">
              {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-316">
                  <button className="w-full flex justify-between items-center p-5 text-left bg-white hover:bg-gray-50 transition-colors duration-200" onClick={() => toggleFAQ(index)} data-id="element-317">
                    <span className="text-lg font-medium text-navy-900" data-id="element-318">
                      {faq.question}
                    </span>
                    {openFAQ === index ? <ChevronUpIcon className="h-5 w-5 text-navy-600" data-id="element-319" /> : <ChevronDownIcon className="h-5 w-5 text-navy-600" data-id="element-320" />}
                  </button>
                  <div className={`px-5 overflow-hidden transition-all duration-300 ${openFAQ === index ? 'max-h-40 pb-5' : 'max-h-0'}`} data-id="element-321">
                    <p className="text-gray-600" data-id="element-322">{faq.answer}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-323" />
    </div>;
}